import { Component, Input } from "@angular/core";

import { UserSubscription } from "./../../models/UserSubscription";

@Component({
  selector: "user-subscription",
  templateUrl: "./user-subscription.component.html",
  styleUrls: ["./user-subscription.component.scss"],
  standalone: false,
})
export class UserSubscriptionComponent {
  @Input() subscription: UserSubscription;
  activeFrom: Date;
  activeTo: Date;

  constructor() {}

  onSubmit() {
    this.subscription.isEditing = false;
    this.subscription.activeFrom = this.activeFrom ?? this.subscription.activeFrom;
    this.subscription.activeTo = this.activeTo ?? this.subscription.activeTo;
  }
}
